import { UserGroups } from '../models/user-groups.enum';
import { UserType } from '../models/user-type.model';
import { User } from '../models/user.model';

export const getUserType = (user: User | undefined): UserType => {
   if (!user) return 'anonymous';
   const { groups } = user;

   if (groups.includes(UserGroups.digitalPlatformGuest)) {
      return 'guest';
   }

   if (groups.includes(UserGroups.digitalPlatformPendingVerification)) {
      return 'pending';
   }

   return 'verified';
};
